import Footer from "../components/Footer";
import { BrandLogo } from "../components/BrandName";
import SEO from "../components/SEO";
import Newsletter from "../components/Newsletter";
import Countdown from "../components/Countdown";
import ProductGrid from "../components/ProductGrid";
import { Truck, RotateCcw, Shield, Award } from "lucide-react";

export default function ShopPage() {
  return (
    <main data-testid="shop-page">
      <SEO
        title="Shop Padel Clothing — Padel Bekleidung"
        path="/shop"
        description="Pre-order the new Padlr. padel collection. Performance t-shirts, shorts & socks. Designed in Switzerland, 20% off first order. | Padel Bekleidung vorbestellen. Designed in Switzerland, 20% Rabatt auf die erste Bestellung."
      />

      {/* Hero with Countdown */}
      <section className="relative pt-32 sm:pt-40 pb-12 sm:pb-16 bg-[#FDFDFD]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6 mb-4">
            <div>
              <p className="text-xs tracking-[0.25em] uppercase text-[#8B6F47] mb-3" style={{ fontStyle: "normal" }}>
                Pre-Order Now
              </p>
              <h1 data-testid="shop-heading"
                className="text-4xl sm:text-5xl lg:text-6xl tracking-tighter text-[#0A0A0A] mb-3">
                Shop
              </h1>
              <p className="text-sm text-[#888] tracking-wide max-w-md">
                Pre-order from our new collection. No payment required now — we'll contact you before shipping.
              </p>
            </div>
            <div className="lg:text-right">
              <p className="text-[10px] tracking-[0.2em] uppercase text-[#888] mb-2" style={{ fontStyle: "normal" }}>
                Collection drops in
              </p>
              <Countdown dark />
            </div>
          </div>
        </div>
      </section>

      {/* Products Grid */}
      <section className="pb-16 sm:pb-24 bg-[#FDFDFD]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <ProductGrid />
        </div>
      </section>

      {/* Trust */}
      <section className="py-12 sm:py-16 border-y border-[#E5E5E5] bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-8">
            <div className="text-center">
              <Truck className="w-6 h-6 mx-auto mb-3 text-[#0A0A0A]" strokeWidth={1.3} />
              <p className="text-xs tracking-[0.15em] uppercase text-[#0A0A0A] mb-1" style={{ fontStyle: "normal" }}>Free Shipping</p>
              <p className="text-xs text-[#888]" style={{ fontStyle: "normal" }}>On orders over CHF 75</p>
            </div>
            <div className="text-center">
              <RotateCcw className="w-6 h-6 mx-auto mb-3 text-[#0A0A0A]" strokeWidth={1.3} />
              <p className="text-xs tracking-[0.15em] uppercase text-[#0A0A0A] mb-1" style={{ fontStyle: "normal" }}>30-Day Returns</p>
              <p className="text-xs text-[#888]" style={{ fontStyle: "normal" }}>Hassle-free exchanges</p>
            </div>
            <div className="text-center">
              <Shield className="w-6 h-6 mx-auto mb-3 text-[#0A0A0A]" strokeWidth={1.3} />
              <p className="text-xs tracking-[0.15em] uppercase text-[#0A0A0A] mb-1" style={{ fontStyle: "normal" }}>Secure Checkout</p>
              <p className="text-xs text-[#888]" style={{ fontStyle: "normal" }}>SSL encrypted payments</p>
            </div>
            <div className="text-center">
              <Award className="w-6 h-6 mx-auto mb-3 text-[#0A0A0A]" strokeWidth={1.3} />
              <p className="text-xs tracking-[0.15em] uppercase text-[#0A0A0A] mb-1" style={{ fontStyle: "normal" }}>Designed in Switzerland</p>
              <p className="text-xs text-[#888]" style={{ fontStyle: "normal" }}>Born in Switzerland</p>
            </div>
          </div>
        </div>
      </section>

      <Newsletter />
      <Footer />
    </main>
  );
}
